module.exports = __webpack_public_path__ + "static/media/totem3.d076e71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/totem3.jpg
// module id = 361
// module chunks = 0